/* eslint-disable no-unused-vars */
import packageJson from "../../package.json";
export const APP_VERSION = packageJson.version;
export const API_URL = process.env.REACT_APP_API_URL;
export const NFT_CLIENT_URL = process.env.REACT_APP_NFT_CLIENT_URL;
export const ADMIN_V2_URL = process.env.REACT_APP_ADMIN_V2_URL;
export const COOKIE_PREFIX = process.env.REACT_APP_COOKIE_PREFIX;
export const COOKIE_DOMAIN = process.env.REACT_APP_COOKIE_DOMAIN;
export const FIREBASE_MESSAGING_PUBLIC_VAPID_KEY =
  process.env.REACT_APP_FIREBASE_MESSAGING_PUBLIC_VAPID_KEY;
export const PACKER_URL = process.env.REACT_APP_PACKER_URL;
export const HOME = "/";
export const STATISTIC = "/statistic/showBy=:showBy&from=:from&to=:to";
export const PRODUCTS = "/products";
export const NFT_COLLECTIONS = "/nft/collections";
export const ADD_NFT_COLLECTION = "/nft/collection/add";
export const EDIT_NFT_COLLECTION = "/nft/collection/:id/edit";
export const NFT_DROPS = "/nft/drops";
export const ADD_NFT_DROP = "/nft/drop/add";
export const EDIT_NFT_DROP = "/nft/drop/:id/edit";
export const NFT_PERKS = "/nft/perks";
export const ADD_NFT_PERK = "/nft/perk/add";
export const EDIT_NFT_PERK = "/nft/perk/:id/edit";
export const ORDERS = "/orders";
export const AREAS = "/areas";
export const PARTNERS = "/partners";
export const SURVEYS = "/surveys";
export const ADD_SURVEY = "/survey/add";
export const EDIT_SURVEY = "/survey/:id/edit";
export const ADD_PARTNER = "/partner/add";
export const EDIT_PARTNER = "/partner/:id/edit";
export const BRANDS = "/brands";
export const BRAND_DASHBOARD = "/brand/:brandId/dashboard";
export const ADMINS = "/admins";
export const BRAND_STATISTIC = "/brand/:brandId/statistics";
export const BRAND_PRODUCTS = "/brand/:brandId/products";
export const BRAND_PRODUCTS_LOGS = "/brand/:brandId/products/logs";
export const BRAND_ORDERS = "/brand/:brandId/orders";
export const BRAND_ORDERS_WITH_TYPE = "/brand/:brandId/orders/:ordersType";
export const BRAND_ORDER = "/brand/:brandId/order/:orderId";
export const BRAND_USERS = "/brand/:brandId/users";
export const BRAND_CUSTOMERS = "/brand/:brandId/customers";
export const BRAND_CUSTOMERS_INFO = "/brand/:brandId/customers/:userId";
export const BRAND_DISPENSARIES = "/brand/:brandId/dispensaries";
export const BRAND_DISPENSARY_METRC =
  "/brand/:brandId/dispensaries/:integrationId/metrc/:tab?/:packageLabel?";
/** Base path without the optional tab/package segments, for building links. */
export const brandDispensaryMetrcPath = (brandId, integrationId) =>
  `/brand/${brandId}/dispensaries/${integrationId}/metrc`;
export const BRAND_BATCHES = "/brand/:brandId/batches";
export const BRAND_REWARDS = "/brand/:brandId/rewards";
export const BRAND_REWARDS_LOG = "/brand/:brandId/rewards/log";
export const BRAND_REWARDS_LOG_INFO = "/brand/:brandId/rewards/log/:taskId";
export const BRAND_SETTINGS = "/brand/:brandId/settings";
export const BRAND_CATEGORIES = "/brand/:brandId/categories";
export const BRAND_MESSAGES = "/brand/:brandId/messages";
export const BRAND_ORDERS_WITH_TYPE_WITHOUT_BRAND_ID =
  "/brand/orders/:ordersType";
export const BRAND_ORDER_WITHOUT_BRAND_ID = "/brand/order/:orderId";

export const ORDER = "/order/number/:number";
export const NOTIFICATIONS = "/notifications";
export const SUPPORT = "/support";
export const SUPPLY = "/supply";
export const CREATE_SUPPLY = "/create-supply-request";
export const SUPPLY_REQUEST = "/supply-request/:id";
export const CONFIG = "/config";
export const SETTINGS = "/settings";
export const SETTINGS_BUNDLES_SURFACES = "/settings/bundles/surfaces";
export const STATISTICS = "/statistics";
export const COURIERS = "/couriers";
export const ADD_COURIER = "/courier/add";
export const COURIER = "/courier/:id";
export const EDIT_COURIER = "/courier/:id/#courier-info";
export const MISSION_INFO = "/mission/:id";
export const SCHEDULE_INFO = "/schedule/:id/:date/";
export const USERS = "/users";
export const STASHBOX = `${ADMIN_V2_URL}`;
export const PRODUCT_POINT = `${ADMIN_V2_URL}/product-point`;
export const GAMES = "/games";
export const ADD_GAME = "/game/add";
export const EDIT_GAME = "/game/:id/edit";
export const GAMES_USERS = "/games/users";
export const CATEGORIES = "/categories";
export const STATES = "/states";
export const QR_SEQUENCES = "/qr-code-sequences";
export const EMPLOYEES = "/employees";
export const DRIVER_ORDERS = "/driver/orders";
export const PASSWORD_FORGET = "/forgot-password";
export const PASSWORD_RESET = "/recovery-password/:passwordResetToken";
export const brandRoutesWithGradientBg = [
  BRAND_MESSAGES,
  BRAND_CUSTOMERS,
  BRAND_CUSTOMERS_INFO,
  BRAND_PRODUCTS,
  BRAND_PRODUCTS_LOGS,
  BRAND_CATEGORIES,
  BRAND_ORDERS_WITH_TYPE,
  BRAND_ORDER_WITHOUT_BRAND_ID,
  BRAND_ORDERS_WITH_TYPE_WITHOUT_BRAND_ID,
  BRAND_ORDER,
  BRAND_USERS,
  BRAND_DISPENSARIES,
  BRAND_DISPENSARY_METRC,
  BRAND_BATCHES,
  BRAND_REWARDS,
  BRAND_REWARDS_LOG,
  BRAND_REWARDS_LOG_INFO,
  BRAND_SETTINGS,
  HOME,
  EMPLOYEES,
  BRANDS,
  DRIVER_ORDERS,
  USERS,
  PASSWORD_FORGET,
  PASSWORD_RESET,
];

export const brandRoutes = [
  BRAND_DASHBOARD,
  BRAND_STATISTIC,
  BRAND_PRODUCTS,
  BRAND_PRODUCTS_LOGS,
  BRAND_ORDERS,
  BRAND_ORDERS_WITH_TYPE,
  BRAND_ORDER,
  BRAND_USERS,
  BRAND_CUSTOMERS,
  BRAND_CUSTOMERS_INFO,
  BRAND_MESSAGES,
  BRAND_DISPENSARIES,
  BRAND_DISPENSARY_METRC,
  BRAND_BATCHES,
  BRAND_REWARDS,
  BRAND_REWARDS_LOG,
  BRAND_REWARDS_LOG_INFO,
  BRAND_SETTINGS,
  BRAND_CATEGORIES,
  BRAND_ORDERS_WITH_TYPE_WITHOUT_BRAND_ID,
  BRAND_ORDER_WITHOUT_BRAND_ID,
  DRIVER_ORDERS,
];

export const ACCESS_TOKEN = "accessToken";
export const REFRESH_TOKEN = "refreshToken";

export const ROLES = {
  superAdmin: "0",
  admin: "1",
  user: "2",
  currier: "3",
  partner: "4",
  brandDriver: "5",
  brandManager: "6",
  brandPacker: "7",
  brandBudtender: "8",
};

export const SuperAdminId = 8;

export const BrandManagerRolesSelect = [
  { id: 6, name: "Manager" },
  { id: 7, name: "Packer" },
  { id: 5, name: "Driver" },
  { id: 8, name: "Budtender" },
];

export const CourierState = {
  0: "finished",
  1: "on mission",
  2: "returning",
};

export const OrderStateString = {
  0: "drafted",
  1: "created",
  2: "assigned",
  3: "reject",
  4: "accepted",
  5: "packing",
  6: "in delivery",
  7: "delivered",
  8: "completed",
  9: "returned",
  10: "canceled",
};

export const OrderPickUpStateString = {
  0: "drafted",
  1: "created",
  2: "assigned",
  3: "reject",
  4: "accepted",
  5: "packing",
  6: "available for pick up",
  7: "completed",
  10: "canceled",
};

export const OrderStateStringFromDialog = {
  6: "in delivery",
  7: "delivered",
  10: "canceled",
};

export const OrderPickUpStateStringFromDialog = {
  5: "packing",
  6: "available for pick up",
  7: "completed",
  10: "canceled",
};

export const OrderStateIndex = {
  drafted: 0,
  created: 1,
  assigned: 2,
  rejected: 3,
  accepted: 4,
  packing: 5,
  "in delivery": 6,
  delivered: 7,
  completed: 8,
  returned: 9,
  canceled: 10,
};

export const OrderPickUpStateIndex = {
  drafted: 0,
  created: 1,
  packing: 5,
  "available for pick up": 6,
  completed: 7,
  canceled: 10,
};

export const requestStatuses = [
  { id: 0, name: "pending" },
  { id: 1, name: "in progress" },
  { id: 2, name: "completed" },
  { id: 3, name: "canceled" },
];

export const courierMissionState = {
  0: "in progress",
  1: "finished",
};

export const orderTypeTab = {
  all: 0,
  delivery: 1,
  pickUp: 2,
};

export const orderType = {
  delivery: 0,
  pickUp: 1,
};

export const perkTypeOptions = [
  { id: -1, name: "None" },
  { id: 0, name: "Cart discount" },
  { id: 1, name: "Increase per buy back" },
];

export const defaultPaginationRowsPerPageOptions = [5, 10, 25];

export const orderV2State = {
  PROCESSING: 0,
  PRODUCT_ON_THE_WAY: 1,
  READY_FOR_PICKUP: 2,
  COMPLETED: 3,
  CANCELED: 4,
};

export const orderV2DeliveryState = {
  PROCESSING: 0,
  PRODUCT_ON_THE_WAY: 1,
  COMPLETED: 3,
  CANCELED: 4,
};

export const orderV2StateText = {
  0: "Processing",
  1: "Product on the way",
  2: "Ready for pick up",
  3: "Completed",
  4: "Canceled",
  5: "Pending payment",
};
export const orderV3StateText = {
  0: "Processing",
  1: "On the way",
  2: "Ready for pick up",
  3: "Completed",
  4: "Canceled",
  5: "Pending payment",
};

export const orderV2StateOptions = [
  {
    id: 0,
    name: "Processing",
  },
  {
    id: 1,
    name: "Product on the way",
  },
  {
    id: 2,
    name: "Ready for pick up",
  },
  {
    id: 3,
    name: "Completed",
  },
];

export const dispensaryTypeOptions = [
  {
    id: 0,
    name: "In house",
  },
  {
    id: 1,
    name: "Third party",
  },
];

export const orderV2DeliveryStateText = {
  0: "Processing",
  1: "Product on the way",
  3: "Completed",
  4: "Canceled",
};

export const orderV2DeliveryStateTextForDriver = {
  0: "Processing",
  1: "On the way",
  3: "Completed",
  4: "Canceled",
};

export const orderV2DeliveryStateOptions = [
  {
    id: 0,
    name: "Processing",
  },
  {
    id: 1,
    name: "Product on the way",
  },
  {
    id: 3,
    name: "Completed",
  },
  {
    id: 4,
    name: "Canceled",
  },
];

export const versionsOs = {
  iOS: 0,
  Android: 1,
  RN_iOS: 2,
  RN_Android: 3,
};

export const types = {
  rewards: 10,
  accessoires: 9,
  seeds: 7,
};

export const orderTimeType = {
  SAME_DAY: 0,
  SCHEDULED: 1,
};

export const defaultSettingForOrderState = [
  {
    minOrder: 0,
    freeDelivery: 0,
    deliveryType: orderTimeType.SAME_DAY,
  },
  {
    minOrder: 0,
    freeDelivery: 0,
    deliveryType: orderTimeType.SCHEDULED,
  },
];

export const defaultSettingForOrderBrand = [
  {
    minOrder: 0,
    freeDelivery: 0,
    deliveryFee: 0,
    deliveryType: orderTimeType.SAME_DAY,
  },
  {
    minOrder: 0,
    freeDelivery: 0,
    deliveryFee: 0,
    deliveryType: orderTimeType.SCHEDULED,
  },
];

export const dispensariesForScheduled = {
  ALL: 0,
  IN_HOUSE: 1,
  THIRD_PARTY: 2,
};

export const ordersTypeSidebar = {
  NEW: 0,
  IN_PROGRESS: 1,
  FULFILLED: 2,
  CANCELED: 3,
  ARCHIVED: 4,
};

export const ordersTypeSidebarText = {
  0: "New orders",
  1: "In progress",
  2: "Fulfilled",
  3: "Canceled",
  4: "Archived",
};

export const notificationTypeEnum = {
  SMS: 0,
  EMAIL: 1,
  PUSH: 2,
};

export const notificationTypeText = {
  0: "text",
  1: "email",
  2: "push",
};

export const notificationState = {
  SENT: 0,
  DELIVERED: 1,
  NOT_DELIVERED: 2,
};

export const notificationStateText = {
  0: "send",
  1: "delivered",
  2: "not delivered",
};

export const fontFamilies = {
  100: "'Core Sans C 15', sans-serif",
  200: "'Core Sans C 25', sans-serif",
  300: "'Core Sans C 35', sans-serif",
  400: "'Core Sans C', sans-serif",
  500: "'Core Sans C 55', sans-serif",
  600: "'Core Sans C 65', sans-serif",
  700: "'Core Sans C 65', sans-serif",
  800: "'Core Sans C 75', sans-serif",
  900: "'Core Sans C 95', sans-serif",
};

export const forbiddenSmsWords = [
  "420",
  "Ashtray",
  "Baked",
  "Blazed",
  "Blunt",
  "Bong",
  "Buddha's lettuce",
  "Bud",
  "Bubbler",
  "CBD",
  "Cannabidiol",
  "Cannabis",
  "Cannabis cup",
  "Canna-business",
  "Cannabis oil",
  "Cheeba",
  "Chronic",
  "Cigarette",
  "Concentrates",
  "Dab",
  "Dab rig",
  "Dab tool",
  "Dank",
  "Dispensary",
  "Dope",
  "Edibles",
  "Four-twenty",
  "Ganja",
  "Ganja farm",
  "Glass blunt",
  "Glassware",
  "Grass",
  "Hash",
  "Hash oil",
  "Haze",
  "Headshop",
  "Hemp",
  "Hemp wick",
  "Herb",
  "Herb grinder",
  "High",
  "Hookah",
  "Hotbox",
  "Hybrid",
  "Hydroponics",
  "Indica",
  "Joint",
  "Joints",
  "Kief",
  "Kush",
  "Legalization",
  "Legalize",
  "Lighter",
  "Marijuana",
  "Mary Jane",
  "Munchies",
  "Nugs",
  "One-hitter",
  "Pipe",
  "Pot",
  "Pre-roll",
  "Puff",
  "Puff and pass",
  "Reefer",
  "Reefer joint",
  "Reefer madness",
  "Resin",
  "Roach",
  "Roach clip",
  "Rolling paper",
  "Rolling tray",
  "Sativa",
  "Smokable",
  "Smoke",
  "Smokescreen",
  "Smoking cessation",
  "Spliff",
  "Spliffing",
  "Stoned",
  "Stoner",
  "Stoner film",
  "THC",
  "THC cartridge",
  "Terpenes",
  "Tincture",
  "Toke",
  "Toke up",
  "Vape",
  "Vape pen",
  "Vapor cloud",
  "Vaporizer",
  "Wake and bake",
  "Weed",
  "Weedhead",
];

export const OrderBulkUpdateAction = {
  ARCHIVE: 0,
  CANCEL: 1,
};

export enum RewardTaskType {
  PROMOTION = 0,
  PRODUCTS = 1,
  STORE_VISIT = 2,
  SURVEY = 3,
  REFERRAL = 4,
  DOWNLOAD_APP = 5,
  GOLDEN_TICKET = 6,
}

export const RewardTaskTypeText = {
  [RewardTaskType.PROMOTION]: "Promotion",
  [RewardTaskType.PRODUCTS]: "Products",
  [RewardTaskType.STORE_VISIT]: "Store Visit",
  [RewardTaskType.SURVEY]: "Survey",
  [RewardTaskType.REFERRAL]: "Referral",
  [RewardTaskType.DOWNLOAD_APP]: "Download App",
  [RewardTaskType.GOLDEN_TICKET]: "Golden Ticket",
};

export enum RewardTaskState {
  ACTIVE = 0,
  WAITING = 1,
  ARCHIVE = 2,
}

export enum AnswerType {
  MULTIPLE_CHOICE_OPTIONS = 0,
  OPEN_ENDED_RESPONSE = 1,
}

export const AnswerTypeText = {
  [AnswerType.MULTIPLE_CHOICE_OPTIONS]: "Multiple Choice Options",
  [AnswerType.OPEN_ENDED_RESPONSE]: "Open-ended response",
};

export enum UpdateRewardTaskQuestionEvent {
  UPDATE = 0,
  CREATE = 1,
  DELETE = 2,
}

export const alphabet = "abcdefghijklmnopqrstuvwxyz".split("");

export const RewardTaskPromotionShared = { INSTAGRAM: 0, TWITTER: 1 };

export const RewardTaskPromotionSharedText = {
  [RewardTaskPromotionShared.INSTAGRAM]: "Instagram",
  [RewardTaskPromotionShared.TWITTER]: "Twitter",
};

export const BrandCustomersActivityType = {
  ORDER: 0,
  REDEEM: 1,
  ACCRUAL_POINTS_BY_WORKER: 2,
  WITHDRAWAL_POINTS_BY_WORKER: 3,
};
